import GetDocumentsTemplate from '@/graphql/ContractualDocuments/GetDocumentsTemplate.gql'
import GetContractualDocument from '@/graphql/ContractualDocuments/GetContractualDocument.gql'
import SaveContractualDocument from '@/graphql/ContractualDocuments/SaveContractualDocument.gql'
import UpdateContractualDocumentEnabled from '@/graphql/ContractualDocuments/UpdateContractualDocumentEnabled.gql'
import UpdateContractualDocumentTemplate from '@/graphql/ContractualDocuments/UpdateContractualDocumentTemplate.gql'
import UpdateContractualDocumentTemplateHtml from '@/graphql/ContractualDocuments/UpdateContractualDocumentTemplateHtml.gql'
import GetDocumentWord from '@/graphql/ContractualDocuments/GetDocumentWord.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getDocumentsTemplate ({ dispatch, commit }, { pageNumber = 1, perPage }) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetDocumentsTemplate,
        fetchPolicy: 'no-cache',
        variables: {
          pageNumber,
          perPage
        }
      })
      return response.data.getDocumentsTemplate
    } catch (err) {
      dispatch('showError', err)
    }
  },

  async getContractualDocument ({ dispatch }, contractualDocumentId) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetContractualDocument,
        fetchPolicy: 'no-cache',
        variables: {
          contractualDocumentId
        }
      })
      return response.data.getContractualDocument
    } catch (err) {
      dispatch('showError', err)
      return null
    }
  },

  async saveContractualDocument ({ dispatch, commit }, { name, documentType, regime, productId }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: SaveContractualDocument,
        fetchPolicy: 'no-cache',
        variables: {
          name,
          documentType,
          regime,
          productId
        }
      })
      if (response.data.saveContractualDocument.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Documento creado exitosamente' })
      }
      return response.data.saveContractualDocument
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },

  async updateContractualDocumentEnabled ({ dispatch, commit }, contractualDocumentId) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateContractualDocumentEnabled,
        fetchPolicy: 'no-cache',
        variables: {
          contractualDocumentId
        }
      })
      if (response.data.updateContractualDocumentEnabled.success) {
        dispatch('addTemporalNotification', { type: 'success', message: `El documento ${contractualDocumentId} se ha actualizado` })
      }
      return response.data.updateContractualDocumentEnabled
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },

  async updateContractualDocumentTemplate ({ dispatch, commit }, { contractualDocumentId, type, template }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateContractualDocumentTemplate,
        fetchPolicy: 'no-cache',
        variables: {
          contractualDocumentId,
          type,
          template
        }
      })
      if (response.data.updateContractualDocumentTemplate.success) {
        dispatch('addTemporalNotification', { type: 'success', message: `El documento ${contractualDocumentId} se ha actualizado` })
      }
      return response.data.updateContractualDocumentTemplate
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },

  async updateContractualDocumentTemplateHtml ({ dispatch, commit }, { contractualDocumentId, template }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateContractualDocumentTemplateHtml,
        fetchPolicy: 'no-cache',
        variables: {
          contractualDocumentId,
          template
        }
      })
      if (response.data.updateContractualDocumentTemplateHtml.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'El documento se ha actualizado' })
      }
      return response.data.updateContractualDocumentTemplateHtml
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },

  async getDocumentWord ({ dispatch, commit }, contractualDocumentId) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetDocumentWord,
        fetchPolicy: 'no-cache',
        variables: {
          contractualDocumentId
        }
      })
      return response.data.getDocumentWord
    } catch (err) {
      dispatch('showError', err)
    }
  }
}
